export const languagesFramework = [
    {
        languages: [
            {id: 1, value: "Javascript", xp: 1.5},
            {id: 2, value: "PHP", xp: 4},
            {id: 3, value: "Twig", xp: 4},
            {id: 4, value: "Css", xp: 3},
            {id: 5, value: "gitHub", xp: 4},
        ],
        frameworks: [
            {id: 1, value: "Symfony", xp: 3},
            {id: 2, value: "Bootstrap", xp: 2},
            {id: 3, value: "React", xp: 0.5},
            {id: 4, value: "wordpress", xp: 0.2},

        ]
    }
]